export default {
  clientId: "8puWuJWZYls1Ylawxm6CMiYREhsGGSyw",
  url: "https://api-uat.socialmaster.mobeats.io",
  socialProfile: "https://profile.socialmaster.com/",
};
